// Auto-import SASS generated CSS
import './index.css';

export {default as Image, ImageProps} from './Image';
export {default as default} from './Image';
